import { createAsyncThunk } from '@reduxjs/toolkit';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { PRODUCTS_IMPORT_SLICE_NAME } from './models';
import {
  IGetImportsListDTO,
  IImportProductsDTO,
  IImportsListResponse,
  IImportStocksDTO,
  IProductsImportTemplateDTO,
  IProductsImportTemplateResponse,
  IStocksImportTemplateDTO,
  IStocksImportTemplateResponse,
} from '@/models/productsImport.model';
import { ProductsImportAPI } from '@/api';

export const getProductsImportTemplate = createAsyncThunk<
  IProductsImportTemplateResponse,
  IProductsImportTemplateDTO,
  { serializedErrorType: IApiError }
>(
  `${PRODUCTS_IMPORT_SLICE_NAME}/getProductsImportTemplate`,
  async (data) => {
    const response = await ProductsImportAPI.getProductsImportTemplate(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getStocksImportTemplate = createAsyncThunk<
  IStocksImportTemplateResponse,
  IStocksImportTemplateDTO,
  { serializedErrorType: IApiError }
>(
  `${PRODUCTS_IMPORT_SLICE_NAME}/getStocksImportTemplate`,
  async (data) => {
    const response = await ProductsImportAPI.getStocksImportTemplate(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getImportsList = createAsyncThunk<
  IImportsListResponse,
  IGetImportsListDTO,
  { serializedErrorType: IApiError }
>(
  `${PRODUCTS_IMPORT_SLICE_NAME}/getImportsList`,
  async (data) => {
    const response = await ProductsImportAPI.getImportsList(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const importProducts = createAsyncThunk<void, IImportProductsDTO, { serializedErrorType: IApiError }>(
  `${PRODUCTS_IMPORT_SLICE_NAME}/importProducts`,
  async (data) => {
    const response = await ProductsImportAPI.importProducts(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const importStocks = createAsyncThunk<void, IImportStocksDTO, { serializedErrorType: IApiError }>(
  `${PRODUCTS_IMPORT_SLICE_NAME}/importStocks`,
  async (data) => {
    const response = await ProductsImportAPI.importStocks(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
